"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToYearMonthDateObject = transformDateToYearMonthDateObject;
function transformDateToYearMonthDateObject(date) {
    if (!date) {
        return undefined;
    }
    return {
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate(),
    };
}
//# sourceMappingURL=transformDateToYearMonthDateObject.js.map